/**
 * Content Upload Manager
 * Wrapper with accordion UI for TestTeacherContent sections
 */

import React from 'react'
import TestTeacherContent from '../../../pages/Teacher/TestTeacherContent'

interface ContentUploadManagerProps {
    lop: string
    chuong: string
    bai: string
    onLopChange: (value: string) => void
    onChuongChange: (value: string) => void
    onBaiChange: (value: string) => void
}

const ContentUploadManager: React.FC<ContentUploadManagerProps> = ({
    lop,
    chuong,
    bai,
    onLopChange,
    onChuongChange,
    onBaiChange
}) => {
    return (
        <div className="space-y-4">
            {/* Use existing TestTeacherContent in embedded mode */}
            {/* It already has all 5 sections: Theory, Video, Infographic, Simulation, Quiz */}
            <TestTeacherContent embedded={true} />
        </div>
    )
}

export default ContentUploadManager
